import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner, Typography } from '@chilecompra/react-kit/components'
import { useEffectOnce } from '@chilecompra/react-kit'
import AirlineCard from './HomeForm.AirlineCard'
import AirlinesSection from './HomeForm.airlinesSection'
import BannerSection from './HomeForm.banner'
import GoodPractices from './HomeForm.goodPractices'
import HowItWorksSection from './HomeForm.howItWorks'
import { onGetSuppliersThunk } from './HomeForm.actions'
import { Column, Root, Row } from './HomeForm.styles'
import InformationMessage from './HomeForm.informationMessage'
import Help from './HomeForm.help'
import { REACT_APP_AFTER_SALE_CONDITIONS, REACT_APP_GOOD_PRACTICES_MANUAL_URL } from '../../config/settings/environment'

/**
 * The HomeForm's container.
 */
const HomeForm = () => {
  const { loading, suppliers } = useSelector(state => state.homeForm)
  const dispatch = useDispatch()

  const handleOpenPDFManual = () => {
    const manualUrl = REACT_APP_GOOD_PRACTICES_MANUAL_URL
    window.open(manualUrl, '_blank')
  }

  const handleOpenAfterSaleConditions = () => {
    const afterSaleConditions = REACT_APP_AFTER_SALE_CONDITIONS
    window.open(afterSaleConditions, '_blank')
  }

  const handleRedirectToUrl = useCallback(url => {
    if (url !== undefined && url !== null && url !== '') {
      window.location.href = url
    }
  }, [])

  useEffectOnce(() => dispatch(onGetSuppliersThunk()))

  return (
    <Root>
      <BannerSection />
      <InformationMessage />
      <HowItWorksSection />
      <AirlinesSection>
        {loading && (
          <Row alignItems="center" justifyContent="center" padding="100px">
            <Spinner />
            <Typography fontSize="18px" lineHeight="22px" margin="0 0 0 20px">
              Cargando información de las aerolíneas...
            </Typography>
          </Row>
        )}
        {!loading && (
          <Row columnSpacing={{ md: 5 }} rowSpacing={5} justifyContent="center">
            {suppliers
              ?.filter(supplier => supplier?.visible)
              ?.map(supplier => (
                <Column key={supplier?.dni} md={4} xs={12}>
                  <AirlineCard
                    enabled={supplier?.enabled}
                    logo={supplier?.logo}
                    message={supplier?.message}
                    name={supplier?.name}
                    onRedirectToUrl={handleRedirectToUrl}
                    url={supplier?.url}
                  />
                </Column>
              ))}
          </Row>
        )}
        <GoodPractices onOpenPDFManual={handleOpenPDFManual} />
      </AirlinesSection>
      <Help onOpenAfterSaleConditions={handleOpenAfterSaleConditions} />
    </Root>
  )
}

export default HomeForm
